<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
                      <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="企业">
              <j-search-select-tag
                @change="corpChange"
                dict="`iwt-wf`.wf_consumer_corp,corp_name,id, 1=1 order by corp_name asc"
                placeholder="请选择企业"
                v-model="queryParam.corpId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="用户">

                            <j-search-select-tag
                :dictOptions="consUserOptions"
                @change="searchQuery"
                placeholder="请选择用户"
                v-model="queryParam.userId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="APPID">
              <a-input placeholder="请输入APPID" v-debounce="searchQuery" v-model="queryParam.appId"></a-input>
            </a-form-item>
          </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="APP名称">
                <a-input placeholder="请输入APP名称" v-debounce="searchQuery" v-model="queryParam.appName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="设备品牌">
                <a-input placeholder="请输入设备品牌" v-debounce="searchQuery" v-model="queryParam.deviceBrand"></a-input>
              </a-form-item>
            </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('用户app系统信息')" icon="download" type="primary">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
        </span>
      </a-table>
    </div>

    <app-user-systeminfo-log-modal @ok="modalFormOk" ref="modalForm"></app-user-systeminfo-log-modal>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AppUserSysteminfoLogModal from './modules/AppUserSysteminfoLogModal'

  export default {
    name: 'AppUserSysteminfoLogList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      AppUserSysteminfoLogModal
    },
    data () {
      return {
        description: '用户app系统信息历史记录管理页面',
        isorter: {
          column: 'createTime',
          order: 'desc'
        },
                ipagination: {
          pageSize: 50,
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '用户',
            align: "center",
            sorter: true,
            dataIndex: 'userId_dictText'
          },
          {
            title: 'APPID',
            align: "center",
            sorter: true,
            dataIndex: 'appId'
          },
          {
            title: 'APP名称',
            align: "center",
            sorter: true,
            dataIndex: 'appName'
          },
          {
            title: '当前版本',
            align: "center",
            sorter: true,
            dataIndex: 'appWgtVersion'
          },
          {
            title: '设备品牌',
            align: "center",
            sorter: true,
            dataIndex: 'deviceBrand'
          },
          {
            title: '设备型号',
            align: "center",
            sorter: true,
            dataIndex: 'deviceModel'
          },
          {
            title: '设备类型',
            align: "center",
            sorter: true,
            dataIndex: 'deviceType'
          },
          {
            title: '系统名称',
            align: "center",
            sorter: true,
            dataIndex: 'osName'
          },
          {
            title: '操作系统版本',
            align: "center",
            dataIndex: 'osVersion'
          },
          {
            title: '运行平台',
            align: "center",
            dataIndex: 'uniPlatform'
          },
          {
            title: 'rom 名称',
            align: "center",
            dataIndex: 'romName'
          },
          {
            title: 'rom 版本',
            align: "center",
            dataIndex: 'romVersion'
          },
          {
            title: '时间',
            align: "center",
            sorter: true,
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/custom/appUserSysteminfo/list",
          delete: "/custom/appUserSysteminfo/delete",
          deleteBatch: "/custom/appUserSysteminfo/deleteBatch",
          exportXlsUrl: "/custom/appUserSysteminfo/exportXls",
          importExcelUrl: "custom/appUserSysteminfo/importExcel",
corpUserList: "/custom/user/list",
        },
        dictOptions: {},
        consUserOptions: [],
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
      this.getConsUser();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
              corpChange () {
        this.queryParam.userId = null;
        this.searchQuery();
        this.getConsUser();
      },
              getConsUser () {
        this.consUserOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          column: 'username',
          order: 'asc',
        };
        getAction(this.url.corpUserList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(user => {
              this.consUserOptions.push({
                value: user.id,
                text: user.nickname
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'userId', text: '用户ID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'appId', text: 'APPID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'appName', text: 'APP名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'appWgtVersion', text: '当前版本', dictCode: '' })
        fieldList.push({ type: 'string', value: 'deviceBrand', text: '设备品牌', dictCode: '' })
        fieldList.push({ type: 'string', value: 'deviceModel', text: '设备型号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'deviceType', text: '设备类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'osName', text: '系统名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'osVersion', text: '操作系统版本', dictCode: '' })
        fieldList.push({ type: 'string', value: 'uniPlatform', text: '运行平台', dictCode: '' })
        fieldList.push({ type: 'string', value: 'romname', text: 'rom 名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'romversion', text: 'rom 版本', dictCode: '' })
        fieldList.push({ type: 'Text', value: 'info', text: '系统信息', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>